<template>
    <div class="container-body">
    <div class="terms-wrapper">
        <div class="content" v-html="terms">
              
        </div>
    
    </div>
    </div>

</template>

<script>
    import TermsController from "../controllers/TermsController"
    export default {
        name: "Terms",
        data() {
            return {
                terms: null
            }
        },
        created() {
            this.controller = new TermsController(this)
        }
    }
</script>